export const formatNumber = (item?: number) => {
    const numberString = item?.toString();
    const parts = numberString?.split(/(?=(?:\d{3})+(?!\d))/);
    const formattedNumber = parts?.join(',');
    return formattedNumber;
}